import { ShieldAlert } from "lucide-react";
import { useT } from "@/lib/i18n";
import { type Notice, resolveNoticeText } from "@/lib/notices";
import { getSupportUrl } from "@/lib/support";
import { Modal } from "./modal";
import { Button } from "./ui/button";

/** System notice with standard copy and a support call to action (falls back to a plain "Got it" when support is not configured). */
export function NoticeModal({ notice, onClose, dismissible = true, wide = false, closeLabel }: { notice: Notice; onClose: () => void; dismissible?: boolean; wide?: boolean; closeLabel?: string }) {
  const t = useT();
  const supportUrl = notice.support ? getSupportUrl() : null;
  return (
    <Modal title={resolveNoticeText(notice.title, t)} onClose={onClose} dismissible={dismissible} wide={wide} compact={notice.compact} icon={<ShieldAlert size={22} />}>
      {notice.paragraphs.map((paragraph, index) => <p className="modal-text" key={index}>{resolveNoticeText(paragraph, t)}</p>)}
      <div className="modal-actions">
        {supportUrl ? <a className="button button--primary button--medium" href={supportUrl} target="_blank" rel="noopener noreferrer">{t("dashboard.notice_support")}</a> : null}
        {notice.closeButton === false ? null : <Button variant={supportUrl ? "ghost" : "primary"} onClick={onClose}>{closeLabel ?? t("dashboard.notice_ok")}</Button>}
      </div>
    </Modal>
  );
}

export function ConfirmModal({ title, description, confirmLabel, pending = false, danger = false, onConfirm, onCancel }: { title: string; description: string; confirmLabel: string; pending?: boolean; danger?: boolean; onConfirm: () => void; onCancel: () => void }) {
  const t = useT();
  return (
    <Modal title={title} onClose={onCancel} dismissible={!pending} closeDisabled={pending}>
      <p className="modal-text">{description}</p>
      <div className="modal-actions">
        <Button variant="ghost" disabled={pending} onClick={onCancel}>{t("dashboard.confirm_cancel")}</Button>
        <Button variant={danger ? "danger" : "primary"} disabled={pending} onClick={onConfirm}>{pending ? "…" : confirmLabel}</Button>
      </div>
    </Modal>
  );
}
